module.exports = __webpack_public_path__ + "static/media/logo.5fcb06d6.svg";